import { createApp } from "vue";
import { createPinia } from "pinia";
import { OhVueIcon, addIcons } from "oh-vue-icons";
import { FaFlag, RiZhihuFill } from "oh-vue-icons/icons";
import "primeicons/primeicons.css";
import PrimeVue from "primevue/config";
import App from "./App.vue";
import router from "./router";
import "@/assets/main.css";
import "@/assets/override.css";
import Button from "primevue/button";
import Aura from "@primeuix/themes/aura";
const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
  },
});
addIcons(FaFlag, RiZhihuFill);

app.component("v-icon", OhVueIcon);
app.component("Button", Button);
app.mount("#app");
